import { Match, Response } from "../types";

export interface MatchRow {
  id: string;
  location: string;
  date: string;
  time: string;
  spots_needed: number;
  note?: string | null;
  link: string;
  created_at: string;
  status: Match["status"];
  owner_id?: string | null;
}

export interface ResponseRow {
  id: string;
  name: string;
  status: Response["status"];
  created_at: string;
  responder_id?: string | null;
}

export const mapMatch = (match: MatchRow): Match => ({
  id: match.id,
  location: match.location,
  date: match.date,
  time: match.time,
  spotsNeeded: match.spots_needed,
  note: match.note || undefined,
  link: match.link,
  responses: [],
  createdAt: match.created_at,
  status: match.status,
  ownerId: match.owner_id || undefined,
});

export const mapResponse = (item: ResponseRow): Response => ({
  id: item.id,
  name: item.name,
  status: item.status,
  respondedAt: item.created_at,
  responderId: item.responder_id || undefined,
});
